import styled from 'styled-components';

import { settings } from 'config';
import { colors } from 'config/theme';

const { MAINTENANCE_BANNER_SHOW } = settings.maintenance_banner;
const maintenanceBannerHeight = MAINTENANCE_BANNER_SHOW ? '24px' : '0px';

export const SidebarWrapper = styled.div<{ expanded: boolean }>`
  padding: 1em;
  padding-left: ${(props) => !props.expanded && '0.5em'};
  padding-right: ${(props) => !props.expanded && '0.5em'};
  border-right: 2px solid ${colors.lightGray};
  min-width: ${(props) => (props.expanded ? '300px' : 'max-content')};
  max-width: ${(props) => (props.expanded ? '300px' : 'max-content')};
  // view height - (banner + header + CUI banners)
  max-height: calc(100vh - (36px + 66px + 46px + ${maintenanceBannerHeight}));
  overflow-y: auto;

  header {
    align-items: center;
    color: #263238;
    display: flex;
    justify-content: space-between;
  }

  hr {
    padding-top: 1em;
  }

  section {
    padding-top: 1em;

    .MuiFormControl-root {
      margin-top: 1em;
    }
  }

  .flagged-select > div {
    padding-left: 6px;
  }

  .date-reviewed > div {
    padding-right: 1.5px;
  }
`;
